import React from 'react';

import { SVGPropsType } from 'src/types';

function Favorite(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M6.99999 1.16666L8.80249 4.81832L12.8333 5.40749L9.91666 8.24832L10.605 12.2617L6.99999 10.3658L3.39499 12.2617L4.08332 8.24832L1.16666 5.40749L5.19749 4.81832L6.99999 1.16666Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default Favorite;
